import React from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';

export default function PartnerGymDisconnectModal(props) {
  const { data, onCancel, onConfirm } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TotalModalWrapper>
      <Modal backgroundColor={theme.subBackground}>
        <HeaderBlock>
          <Title color={theme.text}>{t('myStoreSetting.partnerGym.requestModal.disconnectTitle')}</Title>
          <Subtitle color={theme.subText}>{data?.storeName}</Subtitle>
        </HeaderBlock>
        <Description color={theme.text}>{t('myStoreSetting.partnerGym.requestModal.disconnectDesc')}</Description>
        <ButtonRow>
          <CancelButton
            backgroundColor={theme.buttonFill}
            onClick={onCancel}>
            <CancelButtonText color={theme.text}>{t('myStoreSetting.partnerGym.requestModal.cancel')}</CancelButtonText>
          </CancelButton>
          <ConfirmButton
            backgroundColor={theme.pointRed}
            hoverBg={theme.pointRed}
            onClick={onConfirm}>
            <ConfirmButtonText color={theme.subBackground}>{t('myStoreSetting.partnerGym.requestModal.confirmDisconnect')}</ConfirmButtonText>
          </ConfirmButton>
        </ButtonRow>
      </Modal>
    </TotalModalWrapper>
  );
}

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  align-items: stretch;

  padding: 20px;

  gap: 30px;

  width: 390px;

  border-radius: 10px;

  background-color: ${props => props.backgroundColor};

  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.1);

  overflow: hidden;
`;

const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  margin: 0;

  color: ${props => props.color};
`;

const Subtitle = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  margin: 5px 0 0;

  color: ${props => props.color};
`;

const Spacer = styled.div`
  height: 10px;
`;

const Description = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 30px;

  margin: 0;

  white-space: pre-wrap;

  color: ${props => props.color};
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  gap: 10px;
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;

  background-color: ${props => props.backgroundColor};

  transition: background-color 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.hoverBg || props.backgroundColor};
    }
  }
`;

const ConfirmButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 140px;
  height: 40px;

  border-radius: 10px;

  background-color: ${props => props.backgroundColor};

  transition: background-color 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.hoverBg || props.backgroundColor};
    }
  }
`;

const CancelButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  margin: 0;

  color: ${props => props.color};
`;

const ConfirmButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  margin: 0;

  color: ${props => props.color};
`;
